import React, { useState, useEffect } from "react";
import Date from "../../super_dashboard/components/Date";
import { useNavigate } from "react-router";
import SelectLabels from "../../components/SelectLabels";
import { adminAxios } from "../../axiosInstance";
import { createData } from "../../utility/adminApi";
import { getDataById } from "../../utility/adminApi";
import UploadImage from "../../components/UploadImage";
import { axiosInstance } from "../../axiosInstance";
import DeliveryTimeInput from "../../components/DeliveryTimeInput";

function AddProductForm() {
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [categoryData, setCategoryData] = useState([]);
  const [subsingleData, setSubsingleData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [, setSelectedSubcategory] = useState(null);
  const [formData, setFormData] = useState({
    store: "",
    warehouse: "",
    supplier: "",
    cat_id: "",
    sub_cat_id: "",
    product_name: "",
    password: "",
    sku: "",
    barcode: "",
    quantity: "",
    price: "",
    manufacturing_date: "",
    expiring_date: "",
    product_image: imageUrl,
    description: "",
    is_unlimited: false,
    delivery_time: "",
  });

  const navigate = useNavigate();
  const handleCategoryChange = (value) => {
    setSelectedCategory(value);
    setFormData((prevData) => ({
      ...prevData,
      cat_id: value,
    }));
  };

  const handleSubcategoryChange = (value) => {
    setSelectedSubcategory(value);
    setFormData((prevData) => ({
      ...prevData,
      sub_cat_id: value,
    }));
  };

  const handleSingleFile = async (id, setEditTab = false) => {
    const response = await getDataById("categories/show/", id);
    setSubsingleData(response?.data?.data?.sub_categories);
  };

  const fetchProductData = async () => {
    try {
      const response = await adminAxios.get("categories");
      const data = response?.data?.data;
      setCategoryData(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleImageUpload = async (file) => {
    const formData = new FormData();
    formData.append("image", file);
    try {
      const response = await axiosInstance.post(
        "/api/document/upload",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      const uploadedUrl = response?.data?.data?.url;
      if (uploadedUrl) {
        setImageUrl(uploadedUrl);
        setFormData((prevData) => ({
          ...prevData,
          product_image: uploadedUrl,
        }));
        return uploadedUrl;
      } else {
        return null;
      }
    } catch (error) {
      console.error(" Upload error:", error);
      return null;
    }
  };

  useEffect(() => {
    if (selectedCategory != null) {
      handleSingleFile(selectedCategory);
    }
  }, [selectedCategory]);

  useEffect(() => {
    fetchProductData();
  }, []);

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "number" ? Number(value) : value,
    }));
  };

  const handleDateChange = (year, month, day, type) => {
    setFormData((prevData) => ({
      ...prevData,
      [type]: `${year}-${month}-${day}`,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const data = new FormData();
    for (const key in formData) {
      if (key === "quantity" && formData.is_unlimited) continue;
      if (key === "is_unlimited") {
        data.append(key, formData[key] ? "1" : "0");
        continue;
      }
      if (formData[key] !== null && formData[key] !== "") {
        data.append(key, formData[key]);
      }
    }
    await createData("products/store", data);
    setTimeout(() => {
      navigate("/admin/products");
      setLoading(false);
    }, 2000);
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="bg-white w-full mx-auto shadow-lg rounded-lg p-8"
    >
      <h2 className="text-2xl font-semibold mb-6 text-gray-800 border-b pb-2">
        Product Details
      </h2>
      <div className="flex flex-col md:flex-row md:gap-6 mb-10">
        <div className="flex-1">
          <div className="mb-4">
            <label
              className="block mb-1 font-medium text-gray-700"
              htmlFor="product_name"
            >
              Product Name <span className="text-red-500">*</span>
            </label>
            <input
              className="border border-gray-300 p-2 rounded-md focus:border-primary focus:outline-none w-full"
              placeholder="Product Name"
              type="text"
              name="product_name"
              value={formData.product_name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-4">
            <label
              className="block mb-1 font-medium text-gray-700"
              htmlFor="quantity"
            >
              Quantity <span className="text-red-600">*</span>
            </label>
            <input
              className="border border-gray-300 p-2 rounded-md focus:border-primary focus:outline-none w-full"
              placeholder={formData.is_unlimited ? "Unlimited" : "Quantity"}
              type="number"
              min="1"
              name="quantity"
              value={formData.is_unlimited ? "" : formData.quantity}
              onChange={handleChange}
              disabled={formData.is_unlimited}
              required={!formData.is_unlimited}
            />
            <label className="flex items-center gap-2 mt-2 text-sm text-gray-700 cursor-pointer">
              <input
                type="checkbox"
                checked={formData.is_unlimited}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    is_unlimited: e.target.checked,
                    quantity: e.target.checked ? "" : prev.quantity,
                  }))
                }
              />
              Unlimited stock (no quantity tracking)
            </label>
          </div>

          <div className="mb-4">
            <label
              className="block mb-1 font-medium text-gray-700"
              htmlFor="price"
            >
              Price <span className="text-red-500">*</span>
            </label>
            <input
              className="border border-gray-300 p-2 rounded-md focus:border-primary focus:outline-none w-full"
              placeholder="Price"
              type="number"
              name="price"
              value={formData.price}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="flex-1">
          <div className="mb-4">
            <label
              className="block mb-1 font-medium text-gray-700"
              htmlFor="cat_id"
            >
              Category <span className="text-red-500">*</span>
            </label>
            <SelectLabels
              categoryData={categoryData}
              text="Select a Category"
              valueKey="id"
              labelKey="cat_name"
              onSelectChange={handleCategoryChange}
            />
          </div>
          <div className="mb-4">
            <label
              className="block mb-1 font-medium text-gray-700"
              htmlFor="sub_cat_id"
            >
              Subcategory <span className="text-red-500">*</span>
            </label>
            <SelectLabels
              categoryData={subsingleData}
              text="Select Sub-category"
              valueKey="id"
              labelKey="sub_cat_name"
              onSelectChange={handleSubcategoryChange}
            />
          </div>
        </div>
      </div>

      <h2 className="text-2xl font-semibold mb-6 text-gray-800 border-b pb-2">
        Others
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4 mb-8">
        {/* Image upload in left column */}
        <div>
          <label className="block mb-1 font-medium text-gray-700">Image</label>
          <div className="flex items-center space-x-4">
            <UploadImage
              imageUrl={imageUrl}
              setImageUrl={setImageUrl}
              onImageUpload={handleImageUpload}
            />
            {imageUrl && (
              <img
                src={imageUrl}
                alt="Preview"
                className="w-24 h-24 object-cover rounded border"
              />
            )}
          </div>
          <input
            type="hidden"
            name="product_image"
            value={formData.product_image || ""}
            readOnly
          />
        </div>

        <div>
          <label className="block mb-1 font-medium text-gray-700">
            Delivery Time
          </label>
          <DeliveryTimeInput
            seconds={formData.delivery_time}
            onChange={(seconds) =>
              setFormData((prev) => ({ ...prev, delivery_time: seconds }))
            }
          />
        </div>

        <div>
          <label className="block mb-1 font-medium text-gray-700">Store</label>
          <input
            className="border border-gray-300 p-2 rounded-md focus:border-primary focus:outline-none w-full"
            placeholder="Store"
            type="text"
            name="store"
            value={formData.store}
            onChange={handleChange}
          />
        </div>

        <div>
          <label className="block mb-1 font-medium text-gray-700">
            Warehouse
          </label>
          <input
            className="border border-gray-300 p-2 rounded-md focus:border-primary focus:outline-none w-full"
            placeholder="Warehouse"
            type="text"
            name="warehouse"
            value={formData.warehouse}
            onChange={handleChange}
          />
        </div>

        <div>
          <label className="block mb-1 font-medium text-gray-700">
            Supplier
          </label>
          <input
            className="border border-gray-300 p-2 rounded-md focus:border-primary focus:outline-none w-full"
            placeholder="Supplier"
            type="text"
            name="supplier"
            value={formData.supplier}
            onChange={handleChange}
          />
        </div>

        <div>
          <label className="block mb-1 font-medium text-gray-700">SKU</label>
          <input
            className="border border-gray-300 p-2 rounded-md focus:border-primary focus:outline-none w-full"
            placeholder="SKU"
            type="text"
            name="sku"
            value={formData.sku}
            onChange={handleChange}
          />
        </div>

        <div>
          <label className="block mb-1 font-medium text-gray-700">
            Barcode
          </label>
          <input
            className="border border-gray-300 p-2 rounded-md focus:border-primary focus:outline-none w-full"
            placeholder="Barcode"
            type="text"
            name="barcode"
            value={formData.barcode}
            onChange={handleChange}
          />
        </div>

        <div>
          <label className="block mb-1 font-medium text-gray-700">
            Manufacturing Date
          </label>
          <Date
            onDateChange={handleDateChange}
            type={"manufacturing_date"}
            className="w-full"
          />
        </div>

        <div>
          <label className="block mb-1 font-medium text-gray-700">
            Expiring Date
          </label>
          <Date
            onDateChange={handleDateChange}
            type={"expiring_date"}
            className="w-full"
          />
        </div>
      </div>

      <div className="mb-4">
        <label className="block mb-1 font-medium text-gray-700">
          Product Description
        </label>
        <textarea
          name="description"
          id="product_description"
          className="border border-gray-300 rounded-md p-2 min-h-[70px] w-full focus:border-primary focus:outline-none"
          placeholder="Product description"
          onChange={handleChange}
          value={formData.description}
        ></textarea>
      </div>

      <div className="flex justify-end my-6">
        <button
          type="submit"
          className="w-full md:w-auto px-7 py-3 bg-darkblue hover:bg-blue-900 transition text-white font-medium text-lg rounded-lg shadow"
          disabled={loading}
        >
          {loading ? "Saving..." : "Save Product"}
        </button>
      </div>
    </form>
  );
}

export default AddProductForm;
